/**
 * Defer third-party scripts to load after page is interactive
 * This prevents blocking the main thread during initial page load
 */
export function loadThirdPartyScripts() {
  // Wait for page to be fully loaded and user-interactive
  if (document.readyState === 'complete') {
    scheduleLoad();
  } else {
    window.addEventListener('load', scheduleLoad);
  }
}

function scheduleLoad() {
  // Use requestIdleCallback to load during idle time
  if ('requestIdleCallback' in window) {
    requestIdleCallback(initScripts, { timeout: 3000 });
  } else {
    setTimeout(initScripts, 3000);
  }
}

function initScripts() {
  // NOTE: GTM is already loaded in index.html synchronously
  // Do NOT load it again here to avoid duplicate requests

  // 2. Facebook Pixel
  (function(f: any, b: Document, e: string, v: string, n?: any, t?: any, s?: any) {
    if (f.fbq) return;
    n = f.fbq = function() {
      n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments);
    };
    if (!f._fbq) f._fbq = n;
    n.push = n;
    n.loaded = !0;
    n.version = '2.0';
    n.queue = [];
    t = b.createElement(e) as HTMLScriptElement;
    t.async = !0;
    t.src = v;
    s = b.getElementsByTagName(e)[0];
    s.parentNode?.insertBefore(t, s);
  })(window, document, 'script', 'https://connect.facebook.net/en_US/fbevents.js');
  
  (window as any).fbq('init', '2112253505947884');
  (window as any).fbq('init', '2387198481674607');
  (window as any).fbq('track', 'PageView');
}
